export default [
  {
    icon: "phone",
    text: "(812) 424-34-33",
    href: "tel: +78124243433",
  },
  {
    icon: "tg",
    text: "dell84",
    href: "https://t.me/dell84",
  },
  {
    icon: "mail",
    text: "support@rgpu.pro",
    href: "mailto: support@rgpu.pro",
  },
];
